"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultContactDetails = exports.Address = void 0;
const Address_1 = require("./Address");
Object.defineProperty(exports, "Address", { enumerable: true, get: function () { return Address_1.Address; } });
const DefaultContactDetails_1 = require("./DefaultContactDetails");
Object.defineProperty(exports, "DefaultContactDetails", { enumerable: true, get: function () { return DefaultContactDetails_1.DefaultContactDetails; } });
